/**
 * 画笔对象
 * 依赖jquery
 */
import app from './app.js';
import utils from './utils.js';

export const Pen =  function() {
	this.penSize = 16
	this.container = ''
	this.moveTarget = ''
	this.input = ''

	this.init = init
	this.initSize = initSize
	this.penSizeChangeRealTime = penSizeChangeRealTime
	this.penSizeChange = penSizeChange
	this.bindMoveEvent = bindMoveEvent
	this.bindPenSizeChangeRealTime = bindPenSizeChangeRealTime
	this.bindPenSizeChange = bindPenSizeChange
	this.bindClickEvent = bindClickEvent
	this.changeDotPosition = changeDotPosition
	this.changeDotPositionBySize = changeDotPositionBySize
	this.getPostionBySize = getPostionBySize
	this.getSizeByPostion = getSizeByPostion
}
	
const MIN_PEN_SIZE = 1
const MAX_PEN_SIZE = 120
let container, moveTarget, input

let _this

/**
 * 初始化函数
 */
function init(container, moveTarget, input) {
	_this = this
	this.container = container
	this.moveTarget = moveTarget
	this.input = input
	this.penSize = 16
	$(_this.input).val(_this.penSize)
	this.changeDotPositionBySize(this.penSize)
}

/**
 * 初始化画笔大小
 */
function initSize() {
	this.penSize = 16
	this.changeDotPositionBySize(this.penSize)
	$(this.input).val(this.penSize)
	app.model.changeLineWidth(this.penSize);
}

/**
 * 实时监听画笔尺寸输入框的大小
 * @param  number 	value 	当前输入值
 */
function penSizeChangeRealTime(value) {
	if (parseInt(value) != value) {
		value = parseInt(value)
	}
	if (value > MAX_PEN_SIZE) {
        value = MAX_PEN_SIZE
    } else if (value < MIN_PEN_SIZE) {
        value = MIN_PEN_SIZE
    } else if (isNaN(value)) {
    	value = 0
    }
	// 当输入值处于取值范围时，才有后续操作
	if (value <= MAX_PEN_SIZE && value >= MIN_PEN_SIZE) {
		/*if (value % 2 == 1) {
			value = parseInt(value) + 1
		}*/

		$(_this.input).val(value)
        let position = getPostionBySize(value)
        changeDotPosition(position)
        app.model.changeLineWidth(value);
        this.penSize = value
    }
}

/**
 * 监听画笔尺寸变化
 * @param  selector 	selector 	输入框的选择器
 * @param  number 		value   	当前输入值
 */
function penSizeChange(value) {
	if (value > MAX_PEN_SIZE) {
        value = MAX_PEN_SIZE
    } else if (value < MIN_PEN_SIZE) {
        value = MIN_PEN_SIZE
    }

    if (value % 2 == 1) {
		value = parseInt(value) + 1
	}
   
    $(_this.input).val(value)
    let position = getPostionBySize(value)
    changeDotPosition(position)
    app.model.changeLineWidth(value);
    this.penSize = value
}

/**
 * 绑定点击拖动条事件
 */
function bindClickEvent() {
	$(_this.container).click(function(e) {
		let position = e.offsetX
		_this.penSize = getSizeByPostion(position)
		changeDotPosition(position)
		app.model.changeLineWidth(_this.penSize);
		$(_this.input).val(_this.penSize)
	})
	$(this.moveTarget).click(function(e) {
		e.stopPropagation();
	})
}


/**
 * 自动绑定实时监听画笔尺寸输入框的大小
 */
function bindPenSizeChangeRealTime() {
	$(_this.input).bind("input propertychange change", function(event){
	    _this.penSizeChangeRealTime($(this).val())
	});
}

/**
 * 自动绑定监听画笔尺寸变化
 */
function bindPenSizeChange() {
	$(_this.input).change(function() {
	    _this.penSizeChange($(this).val())
	})

}

/**
 * 绑定拖拽圆点移动修改画笔尺寸大小
 * @param  selector container 拖拽的容器
 * @param  selector target    拖拽的对象
 * @param  function callback  回调函数
 */
function bindMoveEvent(callback='') {
	let _this = this
	if (utils.browserIsPc()) {
		mouseEvent(callback)
	} else {
		touchEvent(callback)
	}
}

/**
 * 鼠标移动事件
 */
function mouseEvent(callback) {
	$(_this.moveTarget).mousedown(function(ev) {
	    let dotLeft = ev.clientX - $(_this.moveTarget).offset().left;
	    document.onmousemove = function (e) {
	        if (e.buttons == 1) {
	            let position = e.clientX - $(_this.container).offset().left - dotLeft;
	            if (position < -4 || position > 176) {
	                return;
	            }
	          	
	            _this.changeDotPosition(position)
	            _this.penSize = _this.getSizeByPostion(position)//Math.ceil((needMove + 6) / 300 * 200)
	            $(_this.input).val(_this.penSize)
	            app.model.changeLineWidth(_this.penSize);
	            if(callback) callback(_this.penSize)
	        }
	    };
	    document.onmouseup = function(event) {
	        document.onmousemove = null
	        document.onmouseup = null
	    }
	})
}

/**
 * 手指触摸事件
 */
function touchEvent(callback) {
	$(_this.moveTarget).on('touchstart', function(ev) {
		let rect = parseInt(document.querySelector(_this.moveTarget).style.left);
		let dotLeft=ev.originalEvent.changedTouches[0].pageX;
	    document.querySelector('.function_desk_mobile').ontouchmove = function (e) {
	            let position =rect+e.changedTouches[0].pageX-dotLeft;
	            if (position < -6 || position > 100) {
	                return;
	            }
	          	
	            _this.changeDotPosition(position)
	            _this.penSize = _this.getSizeByPostion(position)//Math.ceil((needMove + 6) / 300 * 200)
	            $(_this.input).val(_this.penSize)
	            app.model.changeLineWidth(_this.penSize);
	            if(callback) callback(_this.penSize)
	            e.preventDefault()
    			e.stopPropagation()
	    };
	    document.querySelector('.function_desk_mobile').ontouchend = function(event) {
	        document.querySelector('.function_desk_mobile').ontouchmove = null
	        document.querySelector('.function_desk_mobile').ontouchend = null
	    }
	    ev.preventDefault()
    	ev.stopPropagation()
	})
}

/**
 * 修改拖动点的位置
 * @param  selector 	selector 	拖动点的元素
 * @param  number 		position 	所处的位置
 */
function changeDotPosition(position) {
	$(_this.moveTarget).css({
        left: position + 'px',
    });
}

/**
 * 通过尺寸修改拖动点的位置
 * @param  selector 	selector 	拖动点的元素
 * @param  number 		position 	所处的位置
 */
function changeDotPositionBySize(size) {
	$(_this.moveTarget).css({
        left: getPostionBySize(size) + 'px',
    });
}

/**
 * 通过画笔尺寸确定偏移量
 * @param  number 	size 	画笔尺寸
 * @return number      		偏移量
 */
function getPostionBySize(size) {
	let position = size / MAX_PEN_SIZE * $(_this.container).width() - $(_this.moveTarget).width()/2
	return position
}

/**
 * 通过偏移量确定画笔尺寸
 * @param  number 	position 	偏移量
 * @return number      			画笔尺寸
 */
function getSizeByPostion(position) {
	let size = Math.ceil( (position + $(_this.moveTarget).width()/2 ) / $(_this.container).width() * MAX_PEN_SIZE)
	if (size % 2 == 1) {
		size += 1
	}
	return size > 0 ? size : 2
}